import Modal, { ModalPropsType } from './modal';
import Button from '../buttons/button';

export type ConfirmModalPropsType = Omit<
  ModalPropsType,
  'onClose' | 'showCloseButton' | 'footer'
> & {
  onConfirm: () => void;
  onCancel: () => void;
};

function ConfirmModal({
  showModal,
  header,
  content,
  onConfirm,
  onCancel,
  children
}: ConfirmModalPropsType) {
  return (
    <Modal
      showModal={showModal}
      showCloseButton={false}
      onClose={onCancel}
      header={header}
      content={content}
      footer={
        <div className='flex justify-end gap-2'>
          <Button color='green' content='بلی' onClick={onConfirm} />
          <Button color='red' content='خیر' onClick={onCancel} />
        </div>
      }
    >
      {children}
    </Modal>
  );
}

export default ConfirmModal;
